import { createContext } from 'react';

export const BusinessContext = createContext({
  business: null,
});
